import { authAction } from "../context/auth";
import service from "../services/service";
import { getUserAccounts } from "./acc_actions";

export const login = (access_token, navigate) => async (dispatch) => {
  try {
    const invitationToken = localStorage.getItem("invitation_token");

    // Step 1: Helper to sign in the user and dispatch auth data
    const handleSignin = async () => {
      const userData = {
        exchange_token: access_token,
        client_id: "magic-stamp",
        account_id: "__none__",
        include_refresh_token: true,
      };

      const res = await service.signin(userData);
      const authData = res?.data?.body;

      if (!authData) {
        throw new Error("Authentication failed. No auth data returned.");
      }

      await dispatch(
        authAction({
          type: "LOGIN_SUCCESS",
          data: authData,
        }),
      );

      return authData;
    };

    // Step 2: If invitation token exists
    if (invitationToken) {
      try {
        const inviteData = {
          invite_token: invitationToken,
          access_token,
        };

        let inviteStatus;
        try {
          const res = await service.acceptInvite(inviteData);
          inviteStatus = res?.data?.body;
        } catch (error) {
          window.location.reload();
        }

        if (!inviteStatus) {
          throw new Error("Invitation acceptance failed.");
        }

        localStorage.removeItem("invitation_token");

        const authData = await handleSignin();

        if (authData) {
          // await dispatch(getUserAccounts());
          navigate("/overview");
        }

        return; // Exit after invitation login
      } catch (inviteErr) {
        console.error("Invitation flow failed:", inviteErr);
        throw inviteErr;
      }
    }

    // Step 3: Normal login flow
    const authData = await handleSignin();

    if (authData) {
      // await dispatch(getUserAccounts());
      navigate("/overview");
    }
  } catch (error) {
    console.error("Login error:", error.message);
    throw error;
  }
};

export const signout = () => (dispatch) => {
  // Clear all local storage
  localStorage.clear();

  // Dispatch logout action
  dispatch(
    authAction({
      type: "LOGOUT",
    }),
  );
};
